// * Replace default vue exception handler

import Vue from 'vue'
import consola from 'consola'
const debug = process.env.NODE_ENV !== 'production'

Vue.config.productionTip = !debug // Prevent the production tip on Vue startup.
Vue.config.silent = !debug // Suppress all Vue logs and warnings.
Vue.config.devtools = debug // Configure whether to allow vue-devtools inspection
Vue.config.performance = debug // enable component init, compile, render and patch performance tracing in the browser devtool performance/timeline panel.

consola.level = process.env.VUE_APP_CONSOLA_LEVEL // Set level of log
if (debug || process.env.VUE_APP_LOGS === '1') {
  consola.wrapConsole() // Wrap all console with consola
}

const defaultErrorHandler = Vue.config.errorHandler
Vue.config.errorHandler = function (err, vm, info, ...rest) {
  // Call other handler if exist
  let handled = null
  if (typeof defaultErrorHandler === 'function') {
    handled = defaultErrorHandler(err, vm, info, ...rest)
  }
  if (handled === true) {
    return handled
  }

  if (typeof defaultErrorHandler === 'function') {
    return handled
  }

  if (process.env.NODE_ENV !== 'production') {
    console.group()
    console.info(info)
    console.error(err)
    console.trace(vm)
    console.log(rest)
    console.groupEnd()
  } else {
    console.error(err.message || err)
  }
}
